import { Subscription, SubscriptionPlan, VenueFeatures } from '@lunit/shared-types';
import { api } from './client';

export async function getPlans(): Promise<SubscriptionPlan[]> {
  return api.get<SubscriptionPlan[]>('/plans');
}

export async function getVenueSubscription(venueId: string): Promise<Subscription> {
  return api.get<Subscription>(`/venues/${venueId}/subscription`);
}

export async function getVenueFeatures(venueId: string): Promise<VenueFeatures> {
  return api.get<VenueFeatures>(`/venues/${venueId}/features`);
}

